declare const window: any;
export function tagCtaClick({
  element_text,
  element_location,
  content_id,
  section_title,
}: {
  element_text: string;
  element_location: string; 
  content_id: string;
  section_title?: string;
}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "select_content",
    element_text,
    element_location,
    content_type: "CTA",
    content_id,
    section_title: section_title || undefined,
  });
}